import { getI18nJsonProp } from "@/shared/i18n/locales/getI18nJsonProp";
import base from "./base.json";
import charges from "./charges.json";
import credits from "./credits.json";
import shop from "./shop.json";
import stations from "./stations.json";

const fleetAtHome = {
  ...getI18nJsonProp(base, "fleetAtHome"),
  ...getI18nJsonProp(charges, "fleetAtHome"),
  ...getI18nJsonProp(credits, "fleetAtHome"),
  ...getI18nJsonProp(shop, "fleetAtHome"),
  ...getI18nJsonProp(stations, "fleetAtHome"),
};

export default fleetAtHome;
